import { useMemo } from 'react'

import { useGetWebhookTypes } from './use-get-webhooks-types'
import { useGetWebhookTypesCategories } from './use-get-webhooks-types-categories'

export function useWebhookOriginLabel(paymentProfileId: string | undefined) {
  const { data: categories, isLoading: isLoadingCategories } = useGetWebhookTypesCategories(paymentProfileId)
  const { data: types, isLoading: isLoadingTypes } = useGetWebhookTypes(paymentProfileId)

  const typeToDisplayName = useMemo(() => {
    if (!categories || !types) return {}

    const categoryDisplayName = categories.reduce<Record<string, string>>((acc, { category, displayName }) => {
      acc[category] = displayName
      return acc
    }, {})

    return Object.entries(types).reduce<Record<string, string>>((acc, [category, categoryTypes]) => {
      const displayName = categoryDisplayName[category] ?? category
      categoryTypes.forEach(({ type }) => {
        acc[type] = displayName
      })
      return acc
    }, {})
  }, [categories, types])

  const getOriginLabel = (originType: string | undefined): string => {
    if (!originType) return ''
    return typeToDisplayName[originType] ?? ''
  }

  return { getOriginLabel, isLoading: isLoadingCategories || isLoadingTypes }
}
